import { useState } from "react";
import { textes } from "../../constants/textes";
import Hotspots from "../../components/hotspots/hotspots";



export default function HotspotsView() {
    // states
    const [page, setPage] = useState(0);

    const displayPages = () => {
        if (page === 0) {
            return <Hotspots />;
        }
        //  else {
        //     return <TypeAbonnements />;
        // }
    }

    // affichages
    return (
        <div className="container-fluid">
        <h1 className="h4 mb-4 font-weight-bold text_primary"><i className="fa fa-server mr-1"></i> {textes.fr.hotspotslabel}</h1>
            <div style={{ display: "flex", flexDirection: "row", justifyContent: "start", justifyItems: "center" }}>
                <button onClick={() => { setPage(0) }} className={`btn-shadow rounded-0 btn ${page === 0 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.hotspotslabel}</span>
                </button>
                {/* <button onClick={() => { setPage(1) }} className={`btn-shadow rounded-0 btn ${page === 1 ? 'btn-primary' : 'btn-secondary'}`}>
                    <span>{textes.fr.typeabonnementslabel}</span>
                </button> */}
            </div>
            {displayPages()}
        </div>
    )

}